<template lang="html">
  <transition name="fade">
    <div v-show="showKeyplan" ref="container" class='keyplan mb-5' :id="'kp_' + id + '_container_' + floor">
      <div>
        <canvas class="canvas" :id="'kp_' + id + '_canvas_' + floor"></canvas>
        <img v-if="overlayEnabled" class='overlay' :src="overlayImg" :width="overlayWidth + 'px'"/>
      </div>
      <div class="floor-label m-auto pt-2" :style="{ 'width': overlayWidth + 'px' }">
        {{ floorLabel }}
      </div>
      <transition name="fade">
        <div v-if="currentHoveredUnit"
        class="hover-label px-2 py-1" :style="{ left: (hoverLabelPos.x - 20) + 'px', top: (hoverLabelPos.y + 20) + 'px' }">
          <div class="hover-label-name">{{ hoveredFloorplanInfo.name }}</div>
          <div>
            <span v-if="hoveredFloorplanInfo.beds > 0">
              <span class="emphasize">{{ hoveredFloorplanInfo.beds }}</span>
              <span>bed<span v-if="hoveredFloorplanInfo.beds > 1">s</span></span>
              <span v-if="hoveredFloorplanInfo.dens > 0">+ den</span>
            </span>
            <span class="studio emphasize" v-if="hoveredFloorplanInfo.beds < 1">studio</span>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

function hitTest(shape, mx, my, scale) {
  // a 'hit' will be registered if the distance away from the center is less than the radius of the circular object
  if (mx > parseInt(shape.dx, 10) * scale &&
  mx < parseInt(shape.dx + shape.width, 10) * scale &&
  my > parseInt(shape.dy, 10) * scale &&
  my < parseInt(shape.dy + shape.height, 10) * scale) {
    return true;
  }
  return false;
}

function EachSuitePart(context, image, imageFilter, imageSold, dx, dy, width, height, sx, sy, scale, info, textOffsetX, textOffsetY) {
  const self = this;
  self.parent = null;
  self.font = null;
  self.floor = null;
  self.suite_number = null;
  self.context = context;
  self.spritesheet_img = image;
  self.spritesheet_img_filter = imageFilter;
  self.spritesheet_img_sold = imageSold;
  self.dx = dx;
  self.dy = dy;
  self.width = width;
  self.height = height;
  self.sx = sx;
  self.sy = sy;
  self.scale = scale;
  self.status = null;
  self.drawStatus = 'none';
  self.unitNameWithFloor = true;
  self.text_offsetX = textOffsetX;
  self.text_offsetY = textOffsetY;
  self.project_id = 0;


  self.draw = () => {
    self.context.drawImage(self.spritesheet_img, self.sx, self.sy, self.width, self.height, self.dx * self.scale, self.dy * self.scale, self.width * self.scale, self.height * self.scale);
  };

  self.clearDrawStatus = () => {
    self.drawStatus = 'none';
  };

  // reapplying its current highlight based on refreshed availability
  self.reapplyStatus = () => {
    if (self.drawStatus === 'select') {
      self.showFloorplanUnits();
      self.drawText();
    } else if (self.drawStatus === 'filter') {
      self.showFilteredUnits();
      self.drawText();
    }
  };

  self.showSelectedUnits = () => {
    self.context.drawImage(self.spritesheet_img_sold, self.sx, self.sy, self.width, self.height, self.dx * self.scale, self.dy * self.scale, self.width * self.scale, self.height * self.scale);
    self.drawStatus = 'select';
  };

  self.showFloorplanUnits = () => {
    if (self.status === 'available') {
      self.context.drawImage(self.spritesheet_img, self.sx, self.sy, self.width, self.height, self.dx * self.scale, self.dy * self.scale, self.width * self.scale, self.height * self.scale);
      self.drawStatus = 'select';
    }
  };

  self.showFilteredUnits = () => {
    if (self.status === 'available') {
      self.context.drawImage(self.spritesheet_img_filter, self.sx, self.sy, self.width, self.height, self.dx * self.scale, self.dy * self.scale, self.width * self.scale, self.height * self.scale);
      self.drawStatus = 'filter';
    }
  };

  self.drawText = () => {
    // if (!self.status) {
    //   // console.log(self.floor + ',' + self.suite_number);
    // }
    // if (self.status === 'available' || self.status === 'sold') {
    //   var textLocX = (self.dx * self.scale + (self.dx + self.width) * self.scale) / 2;
    //   var textLocY = (self.dy * self.scale + (self.dy + self.height) * self.scale) / 2;
    // }
  };
}

export default {
  props: ['id', 'nodeData', 'floor', 'displayChanged'],
  data() {
    return {
      // id: null,
      units: [],
      canvas: null,
      spriteSheet: '',
      soldSpriteSheet: '',
      filterSpriteSheet: '',
      image: '',
      imageWidth: 0,
      imageHeight: 0,
      overlayImg: '',
      overlayWidth: 0,
      overlayEnabled: true,
      url: '',
      spritesheetUrl: '',
      soldSpritesheetUrl: '',
      filterSpritesheetUrl: '',
      context: null,
      ready: false,
      loadedSheets: 0,
      activeUnits: 0,
      resizeTimeout: null,
      canvasDimensions: { width: 1, height: 1 },
      lastDimensions: { width: 1, height: 1 },
      kpScale: 1,
      currentHoveredUnit: '',
      hoverLabelPos: {
        x: 0,
        y: 0
      }
    };
  },
  computed: {
    ...mapState({
      assetsUrl: state => state.project.assetsUrl,
      mobileShowAvailability: state => state.ui.mobileShowAvailability,
      displayMode: state => state.floorplans.availability.displayMode,
      selectedUnitName: state => state.floorplans.selectedUnitName
    }),
    ...mapGetters({
      filteredUnitList: 'floorplans/filteredUnitList',
      floorplanAvailabltUnitList: 'floorplans/floorplanAvailableUnitList',
      getFloorplanByUnitName: 'floorplans/getFloorplanByUnitName',
      deviceMd: 'ui/deviceMd',
    }),
    floorLabel() {
      let retString = '';
      if (this.floor) {
        retString = `Floor ${this.floor}`;
      }
      return retString;
    },
    showKeyplan() {
      // Hides kp if in detail mode but no units available.
      return this.activeUnits > 0 || this.$route.name === 'FloorplanList';
    },
    hoveredFloorplanInfo() {
      return this.getFloorplanByUnitName(this.currentHoveredUnit);
    }
  },
  methods: {
    ...mapMutations({
      toggleMobileShowAvailability: 'ui/toggleMobileShowAvailability',
      setSelectedUnitName: 'floorplans/setSelectedUnitName'
    }),
    resizeCanvas() {
      if (this.canvas) {
        this.canvas.width = this.canvasDimensions.width;
        this.canvas.height = this.canvasDimensions.height;

        console.log('resize canvas to', this.canvas.width, this.canvas.height);
      }
    },
    onResizeEnded() {
      let rect = null;
      let sizeUpdate = false;
      if (this.$refs.container) {
        rect = this.$refs.container.getBoundingClientRect();
      }
      if (this.image && rect) {
        if (this.imageWidth) {
          const tempUpdate = { width: 1, height: 1 };
          let tempScale = 1;
          tempUpdate.width = this.imageWidth;
          tempUpdate.height = this.imageHeight;
          // console.log('imageW', this.imageWidth);
          // console.log('rectW', rect.width);
          // console.log('canvDim', this.canvasDimensions.width);
          if (this.imageWidth > rect.width) {
            tempUpdate.width = Math.floor(rect.width);
            tempScale = tempUpdate.width / this.imageWidth;
            tempUpdate.height = Math.floor(this.imageHeight * tempScale);
          }

          if (tempUpdate.width !== this.lastDimensions.width) {
            // console.log(tempUpdate, this.lastDimensions);
            sizeUpdate = true;
          }

          if (sizeUpdate) {
            // console.log('size update required');
            this.canvasDimensions = tempUpdate;
            this.kpScale = tempScale;

            this.units.forEach((unit) => {
              unit.scale = this.kpScale;
            });

            this.canvas.width = this.canvasDimensions.width;
            this.canvas.height = this.canvasDimensions.height;
            this.lastDimensions.width = this.canvas.width;
            this.lastDimensions.height = this.canvas.height;
            this.overlayWidth = this.canvasDimensions.width;
          }
          this.updateUnits();
        }
      }
    },
    /* Initialization */
    buildKP(kpNodeData) {
      if (this.ready === false) {
        this.nodeData = kpNodeData;

        this.id = this.nodeData.id;
        this.url = this.assetsUrl + this.nodeData.url;
        this.overlayImg = this.assetsUrl + this.nodeData.url.replace('.png', '_text.png');
        this.spritesheetUrl = this.assetsUrl + this.nodeData.spritesheet_url;
        this.soldSpritesheetUrl = this.assetsUrl + this.nodeData.spritesheet_url.replace('.png', '_sold.png');
        this.filterSpritesheetUrl = this.assetsUrl + this.nodeData.spritesheet_url.replace('.png', '_filter.png');

        this.image = new Image();
        this.image.src = this.url;
        this.image.onload = this.loadSpritesheet;
      }
    },
    loadSpritesheet() {
      if (this.ready === false) {
        this.spriteSheet = new Image();
        this.spriteSheet.src = this.spritesheetUrl;
        this.spriteSheet.onload = this.setupCanvas;

        this.soldSpriteSheet = new Image();
        this.soldSpriteSheet.src = this.soldSpritesheetUrl;
        this.soldSpriteSheet.onload = this.setupCanvas;

        this.filterSpriteSheet = new Image();
        this.filterSpriteSheet.src = this.filterSpritesheetUrl;
        this.filterSpriteSheet.onload = this.setupCanvas;

        this.imageWidth = this.image.naturalWidth;
        this.imageHeight = this.image.naturalHeight;
      }
    },
    setupCanvas() {
      this.loadedSheets += 1;
      if (this.loadedSheets === 3) {
        const canvasID = `kp_${this.id}_canvas_${this.floor}`;
        this.canvas = document.getElementById(canvasID);
        this.canvas.width = this.image.naturalWidth;
        this.canvas.height = this.image.naturalHeight;

        this.lastDimensions.width = this.canvas.width;
        this.lastDimensions.height = this.canvas.height;
        this.canvasDimensions = this.lastDimensions;
        this.overlayWidth = this.canvasDimensions.width;

        this.redrawCleanCanvas();
        this.initEvents();
        this.buildUnits();

        // Initial check to see if window started smaller than full size kp
        this.onResizeEnded();
      }
    },
    redrawCleanCanvas() {
      this.context = this.canvas.getContext('2d');
      this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.context.drawImage(this.image, 0, 0, this.canvasDimensions.width, this.canvasDimensions.height);
      this.units.forEach((unit) => {
        unit.clearDrawStatus();
      });
    },
    initEvents() {
      // this.canvas.removeEventListener('mouseup', this.mouseUp);
      // this.canvas.removeEventListener('mousemove', this.mouseXY);
      // this.canvas.removeEventListener('mouseleave', this.mouseLeave);
      this.canvas.addEventListener('click', this.mouseUp);
      this.canvas.addEventListener('mousemove', this.mouseMove);
      this.canvas.addEventListener('mouseleave', this.mouseLeave);

      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          this.onResizeEnded();
        }, 100);
      });
    },
    buildUnits() {
      const unitsToBuild = Object.values(this.nodeData.coordinates);
      unitsToBuild.forEach((value) => {
        const dx = parseInt(value.x, 10);
        const dy = parseInt(value.y, 10);
        const width = parseInt(value.w, 10);
        const height = parseInt(value.h, 10);
        const sx = parseInt(value.sx, 10);
        const sy = parseInt(value.sy, 10);

        const eachSuite = new EachSuitePart(this.context, this.spriteSheet, this.filterSpriteSheet, this.soldSpriteSheet, dx, dy, width, height, sx, sy, this.kpScale, value);
        // eachSuite.font = self.font;
        eachSuite.floor = self.floor;
        eachSuite.suite_number = value.name;

        let floor = this.floor.toString();
        if (floor.length === 1) floor = `0${floor}`;
        let number = value.name.toString();
        if (number.length === 1) number = `0${number}`;
        eachSuite.number = floor + number;

        let status = 'none';
        const matchedUnit = this.filteredUnitList.find(unit => unit === eachSuite.number);
        if (matchedUnit) {
          status = 'available';
        }
        eachSuite.status = status;

        this.units.push(eachSuite);
      });
      this.ready = true;
    },

    /* Interaction / Control Units */
    getMousePos(evt) {
      const rect = this.canvas.getBoundingClientRect();
      const returnXY = {
        x: evt.clientX - rect.left,
        y: evt.clientY - rect.top
      };
      // console.log(returnXY);
      return returnXY;
    },
    mouseMove(eve) {
      eve.stopPropagation();
      eve.preventDefault();
      const pos = this.getMousePos(eve);
      let hitCount = 0;
      this.units.forEach((unit) => {
        if (hitTest(unit, pos.x, pos.y, this.kpScale) && unit.status === 'available') {
          this.hoverLabelPos.x = pos.x;
          this.hoverLabelPos.y = pos.y;
          this.currentHoveredUnit = unit.number;
          hitCount += 1;
          document.body.style.cursor = 'pointer';
        }
      });

      if (hitCount === 0) {
        this.currentHoveredUnit = '';
        document.body.style.cursor = 'default';
      }
    },
    mouseLeave() {
      this.currentHoveredUnit = '';
      document.body.style.cursor = 'default';
    },
    mouseUp(eve) {
      eve.stopPropagation();
      eve.preventDefault();
      const pos = this.getMousePos(eve);
      this.units.forEach((unit) => {
        if (hitTest(unit, pos.x, pos.y, this.kpScale)) {
          // Only allow units that are 'filtered' and available
          if (unit.status === 'available' &&
              (unit.drawStatus === 'filter' || unit.drawStatus === 'select')) {
            this.unitClicked(unit);
          }
        }
      });
    },
    showSelectedUnits(targetUnit) {
      const foundUnit = this.units.find(unit =>
        unit.suite_number === targetUnit
        || parseInt(unit.suite_number, 10) === parseInt(targetUnit, 10)
      );
      if (foundUnit) {
        foundUnit.showSelectedUnits();
      }
    },
    showFloorplanUnits(targetUnit) {
      const foundUnit = this.units.find(unit =>
        unit.suite_number === targetUnit
        || parseInt(unit.suite_number, 10) === parseInt(targetUnit, 10)
      );
      if (foundUnit) {
        foundUnit.showFloorplanUnits();
      }
    },
    showFilteredUnits(targetUnit) {
      const foundUnit = this.units.find(unit =>
        unit.suite_number === targetUnit
        || parseInt(unit.suite_number, 10) === parseInt(targetUnit, 10)
      );
      if (foundUnit) {
        foundUnit.showFilteredUnits();
      }
    },
    unitClicked(unit) {
      let adjustedFloor = this.floor;
      let adjustedUnit = unit.suite_number;
      if (adjustedFloor.length === 1) {
        adjustedFloor = `0${adjustedFloor}`;
      }
      if (adjustedUnit.length === 1) {
        adjustedUnit = `0${adjustedUnit}`;
      }
      const unitNumber = adjustedFloor + adjustedUnit;
      this.$router.push({
        name: 'FloorplanDetail',
        params: { id: this.getFloorplanByUnitName(unitNumber).id }
      });
      this.setSelectedUnitName(unitNumber);
      this.$emit('selectedUnit', true);
      if (!this.deviceMd) {
        this.toggleMobileShowAvailability();
      }
    },
    updateUnits() {
      if (this.ready) {
        this.redrawCleanCanvas();
        this.filteredUnitList.forEach((unit) => {
          let floor = unit.substring(0, 2);
          if (floor.substring(0, 1) === '0') {
            floor = unit.substring(1, 2);
          }
          const unitNum = unit.substring(2);
          if (this.floor === floor) {
            this.showFilteredUnits(unitNum);
          }
        });
        if (this.$route.name === 'FloorplanDetail') {
          this.activeUnits = 0;
          this.floorplanAvailabltUnitList(this.$route.params.id)
            .forEach((unit) => {
              let floor = unit.substring(0, 2);
              if (floor.substring(0, 1) === '0') {
                floor = unit.substring(1, 2);
              }
              const unitNum = unit.substring(2);
              if (this.floor === floor) {
                // console.log('select Unit', unitNum);
                this.showFloorplanUnits(unitNum);
                this.activeUnits += 1;
              }
            });
        }
        if (this.selectedUnitName) {
          let floor = this.selectedUnitName.substring(0, 2);
          if (floor.substring(0, 1) === '0') {
            floor = this.selectedUnitName.substring(1, 2);
          }
          const unitNum = this.selectedUnitName.substring(2);
          if (this.floor === floor) {
            this.showSelectedUnits(unitNum);
          }
        }
      }
    }
  },
  created() {

  },
  watch: {
    nodeData: {
      immediate: true,
      handler() {
        if (!this.ready && this.nodeData) {
          this.buildKP(this.nodeData);
        }
      }
    },
    selectedUnitName() {
      this.updateUnits();
    },
    filteredUnitList() {
      this.updateUnits();
    },
    $route() {
      this.onResizeEnded();
      this.updateUnits();
    },
    mobileShowAvailability() {
      this.onResizeEnded();
      this.updateUnits();
    },
    displayMode() {
      this.onResizeEnded();
      this.updateUnits();
    },
    showKeyplan() {
      setTimeout(() => {
        this.onResizeEnded();
        this.updateUnits();
      }, 200);
    },
    displayChanged() {
      setTimeout(() => {
        this.onResizeEnded();
        this.updateUnits();
      }, 200);
    }
  }
};
</script>

<style lang="scss" scoped>
.keyplan {
  position: relative;
}

.floor-label {
  position: relative;
  text-align: center;
  font-size: 1.6rem;
  font-family: Scandia-Regular, sans-serif;
  color: var(--text-dark);
  text-transform: uppercase;
}

.overlay {
  position:absolute;
  left: 50%;
  transform: translate3d(-50%,0,0);
  top: 0;
  pointer-events: none;
}

.hover-label {
  background: black;
  color: white;
  position: absolute;
  width: 100px;
  top: 0;
  left: 0;
  pointer-events: none;
  text-align: left;
  font-size: 0.8rem;

  .hover-label-name {
    font-size: 1rem;
    font-family: Scandia-Regular, sans-serif;
  }

  .studio, .exposure {
    text-transform: uppercase;
  }

  .emphasize {
    font-family: Scandia-Regular, sans-serif;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/Availability/AvailabilityKeyplan.vue